import { useEffect, useState } from "react";
const heroVideo = "/hero.mp4";
import { useLanguage } from "@/contexts/LanguageContext";

export default function Hero() {
  const [videoError, setVideoError] = useState(false);
  const [parallaxY, setParallaxY] = useState(0);
  const { t } = useLanguage();

  // subtle parallax on background media
  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        const y = window.scrollY;
        setParallaxY(y * -0.08);
        raf = 0;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <section className="relative w-full h-[100svh] section-snap overflow-hidden">
      <div 
        className="absolute inset-0 z-10" 
        style={{ 
          transform: `translate3d(0, ${parallaxY}px, 0)`,
          willChange: 'transform'
        }}
      >
        {videoError ? (
          <div className="h-full w-full bg-black" />
        ) : (
          <video
            className="h-full w-full object-cover"
            autoPlay
            muted
            playsInline
            preload="metadata"
            onError={() => setVideoError(true)}
            loop
            poster="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1920' height='1080'%3E%3Crect fill='%23000000' width='1920' height='1080'/%3E%3C/svg%3E"
          >
            <source src={heroVideo} type="video/mp4" />
          </video>
        )}
      </div>
    </section>
  );
}